import React from 'react';
import styles from "../Styles/NotFound.module.css"

const NotFound = () => {
    return (
        <h1>Page Not Found</h1>
    )
}

export { NotFound }